import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
`

export const Th = styled.th`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  padding: 8px 12px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Td = styled.td`
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.tableRowAlt};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tableRowHover};
  }
`

export const TableContainer = styled.div`
  overflow-x: auto;
  max-width: 100%;
`

export const StatusMessage = styled.p`
  font-weight: bold;
  color: ${({ $status, theme }) =>
    $status === 'success'
      ? theme.colors.success
      : $status === 'warning'
        ? '#f59e0b'
        : $status === 'error'
          ? theme.colors.danger
          : theme.colors.textPrimary};
`
